// import React, { useState, Component } from "react";
// export default class DeleteUser extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {};
//   }

//   render() {
//     return <div>delete user</div>;
//   }
// }

import React, { Component } from "react";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  Divider,
  Switch,
  TextField,
  Typography,
  colors
} from "@material-ui/core";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css";
import axios from "axios";
import "./userAction.css";
import _apiData from "../../metaData";

let apiData = _apiData[0];

function _isPhone(phone) {
  var regex = /^(\+\d{1,3}[- ]?)?\d{10}$/;
  return regex.test(phone);
}

class DeleteClient extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deleteMobile: "",
      deleteReason: "",
      blockOrUnBlockReason: "",
      blockOrUnBlockMobile: "",
      logoutMobile: "",
      modalHeader: "Header",
      loadLogoutAgent: false,
      loadUnBlock: false,
      loadBlock: false,
      loadDelete: false
    };
    this.checkBlockOrUnBlock = this.checkBlockOrUnBlock.bind(this);
    this.callUnBlockApi = this.callUnBlockApi.bind(this);
    this.callDeleteAgentApi = this.callDeleteAgentApi.bind(this);
    this.callBlockApi = this.callBlockApi.bind(this);
    this.callLogoutApi = this.callLogoutApi.bind(this);
  }

  componentDidMount(){
    if(this.props.location.state && this.props.location.state.email){
      this.setState({deleteMobile: this.props.location.state.email});
    }
  }

  deleteAgent(e) {
    e.preventDefault();
    console.log(this.state, "stateee");
    console.log(_isPhone(this.state.deleteMobile), "ismob");
    if (!this.state.deleteMobile) {
      toast.error("Please Enter Mobile Number", {
        position: toast.POSITION.TOP_RIGHT
      });
    // } else if (!_isPhone(this.state.deleteMobile)) {
    //   toast.error("Please Check Mobile Number", {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    } else if (!this.state.deleteReason) {
      toast.error("Please Enter The Reason To Delete", {
        position: toast.POSITION.TOP_RIGHT
      });
    } else {
      this.setState({
        loadDelete: true
      });
      this.callDeleteAgentApi();
      //   if (window.confirm("Are you sure you wish to delete ?")) {
      //     this.callDeleteAgentApi();
      //   }
    }
  }
  callDeleteAgentApi() {
    let data = {};
    data.username = this.state.deleteMobile;
    data.reason = this.state.deleteReason;
    axios
      .delete(apiData.add_client.url, {
        data: data,
        headers: apiData.headers
      })
      .then(res => {
        if(res.data.ok){
          toast.success("Client Deleted Sucessfully", {
            position: toast.POSITION.TOP_RIGHT
          });
          this.setState({
            deleteMobile: "",
            deleteReason: ""
          })
        }
        // this.setState({
        //   loadDelete: false
        // });
        // console.log(res, "res dell");
        // if (res.data.ok) {
        //   document.getElementById("deleteForm").reset();
        //   toast.success("Sucessfully Deleted!", {
        //     position: toast.POSITION.TOP_RIGHT
        //   });
        //   console.log(res.data, "res dell");
        // } else {
        //   toast.error(
        //     res.data.error.reason ? res.data.error.reason : "Error!",
        //     {
        //       position: toast.POSITION.TOP_RIGHT
        //     }
        //   );
        // }
      });
    console.log("delete api calleddd");
  }
  unBlockAgent(e) {
    e.preventDefault();
    if (this.checkBlockOrUnBlock()) {
      this.setState({
        loadUnBlock: true
      });
      this.callUnBlockApi();
      //   if (window.confirm("Are you sure you wish to Un-Block?")) {
      //     this.callUnBlockApi();
      //   }
    }
  }
  callUnBlockApi(e) {
    let data = {};
    data.username = this.state.blockOrUnBlockMobile;
    data.reason = this.state.blockOrUnBlockReason;
    axios
      .post(apiData.unBlockAgent_2.url, data, {
        headers: apiData.headers
      })
      .then(res => {
        this.setState({
          loadUnBlock: false
        });
        console.log(res, "respounblock");
        if (res.data.ok) {
          document.getElementById("blockOrUnBlockForm").reset();
          toast.success("Sucessfully Un-Blocked!", {
            position: toast.POSITION.TOP_RIGHT
          });
          this.setState({
            blockOrUnBlockMobile: "",
            blockOrUnBlockReason: ""
          })
          console.log(res.data, "res dell");
        } else {
          toast.error(
            res.data.error.reason ? res.data.error.reason : "Error!",
            {
              position: toast.POSITION.TOP_RIGHT
            }
          );
        }
      });
    console.log("call un block API");
  }
  blockAgent(e) {
    e.preventDefault();
    if (this.checkBlockOrUnBlock()) {
      this.setState({
        loadBlock: true
      });
      this.callBlockApi();
      //   if (window.confirm("Are you sure you wish to Block?")) {
      //     this.callBlockApi();
      //   }
    }
  }
  callBlockApi(e) {
    let data = {};
    data.username = this.state.blockOrUnBlockMobile;
    data.reason = this.state.blockOrUnBlockReason;

    axios
      .post(apiData.blockAgent_2.url, data, {
        headers: apiData.headers
      })
      .then(res => {
        this.setState({
          loadBlock: false
        });
        console.log(res, "respounblock");
        if (res.data.ok) {
          document.getElementById("blockOrUnBlockForm").reset();
          toast.success("Sucessfully Blocked!", {
            position: toast.POSITION.TOP_RIGHT
          });
          this.setState({
            blockOrUnBlockMobile: "",
            blockOrUnBlockReason: ""
          })
          console.log(res.data, "res dell");
        } else {
          toast.error(
            res.data.error.reason ? res.data.error.reason : "Error!",
            {
              position: toast.POSITION.TOP_RIGHT
            }
          );
        }
      });

    console.log("call block API");
  }
  checkBlockOrUnBlock() {
    let result = false;
    if (!this.state.blockOrUnBlockMobile) {
      toast.error("Please Enter Moile Number To Block/Un-Block", {
        position: toast.POSITION.TOP_RIGHT
      });
    // } else if (!_isPhone(this.state.blockOrUnBlockMobile)) {
    //   toast.error("Please Check Mobile Number", {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    } else if (!this.state.blockOrUnBlockReason) {
      toast.error("Please Enter Reason To Block/Un-Block", {
        position: toast.POSITION.TOP_RIGHT
      });
    } else {
      result = true;
    }
    return result;
  }

  logoutAgent(e) {
    e.preventDefault();
    if (!this.state.logoutMobile) {
      toast.error("Please Enter Moile Number To Logout Agent", {
        position: toast.POSITION.TOP_RIGHT
      });
    // } else if (!_isPhone(this.state.logoutMobile)) {
    //   toast.error("Please Check Moile Number", {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    } else {
      this.setState({
        loadLogoutAgent: true
      });
      this.callLogoutApi();
      //   if (window.confirm("Are you sure you wish to Logout the Agent?")) {
      //     this.callLogoutApi();
      //   }
    }
  }
  callLogoutApi(e) {
    console.log("callLogoutApi");
    let data = {};
    data.username = this.state.logoutMobile;

    axios
      .post(apiData.logoutAgent.url, data, {
        headers: apiData.headers
      })
      .then(res => {
        this.setState({
          loadLogoutAgent: false
        });
        console.log(res, "respounblock");
        if (res.data.ok) {
          document.getElementById("logoutForm").reset();
          toast.success("Sucessfully Logedout!", {
            position: toast.POSITION.TOP_RIGHT
          });
          this.setState({
            logoutMobile: ""
          })
          console.log(res.data, "res dell");
        } else {
          toast.error(
            res.data.error.reason ? res.data.error.reason : "Error!",
            {
              position: toast.POSITION.TOP_RIGHT
            }
          );
        }
      });
  }

  render() {
    return (
      <>
        <div className="container hole-container" style={{ width: "60em" }}>
          <h6 className="page-header">Delete Client</h6>
          <form className="form-style" id="deleteForm">
            <div className="row data-row">
              <div className="col-md-2 label-class">
                <span className="label-text">Email</span>
              </div>
              <div className="col-md-10 select-bordered-div">
                <Grid item md={12} xs={12}>
                  <TextField
                    fullWidth
                    // label="Select State"
                    // type="number"
                    name="state"
                    label="Client Email"
                    onChange={e => {
                      this.setState({ deleteMobile: e.target.value });
                    }}
                    // select
                    // eslint-disable-next-line react/jsx-sort-props
                    // SelectProps={{ native: true }}
                    value={this.state.deleteMobile}
                    variant="outlined"
                  ></TextField>
                </Grid>
              </div>
            </div>

            <div className="row data-row">
              <div className="col-md-2 label-class">
                <span className="label-text">Reason</span>
              </div>
              <div className="col-md-10 select-bordered-div">
                <Grid item md={12} xs={12}>
                  <TextField
                    fullWidth
                    // label="Select State"
                    name="state"
                    label="Reason For Deleting"
                    onChange={e => {
                      this.setState({ deleteReason: e.target.value });
                    }}
                    // select
                    // eslint-disable-next-line react/jsx-sort-props
                    // SelectProps={{ native: true }}
                    value={this.state.deleteReason}
                    variant="outlined"
                  ></TextField>
                </Grid>
              </div>
            </div>

            <br />
            <div className="row">
              <div className="col-md-10"></div>
              <div className="col-md-2">
                <Button
                  variant="contained"
                  onClick={this.deleteAgent.bind(this)}
                  color="primary"
                  component="span"
                  disabled={this.state.loadDelete}
                >
                  {this.state.loadDelete ? "LOADING..." : "DELETE"}
                </Button>
              </div>
            </div>
          </form>
        </div>

        <br />
        <br />
        <br />

        <div className="container hole-container" style={{ width: "60em" }}>
          <h6 className="page-header">Block/Un-Block Client</h6>
          <form className="form-style" id="blockOrUnBlockForm">
            <div className="row data-row">
              <div className="col-md-2 label-class">
                <span className="label-text">Email</span>
              </div>
              <div className="col-md-10 select-bordered-div">
                <Grid item md={12} xs={12}>
                  <TextField
                    fullWidth
                    // label="Select State"
                    name="state"
                    label="Client Email"
                    onChange={e => {
                      this.setState({ blockOrUnBlockMobile: e.target.value });
                    }}
                    // select
                    // eslint-disable-next-line react/jsx-sort-props
                    // SelectProps={{ native: true }}
                    value={this.state.blockOrUnBlockMobile}
                    variant="outlined"
                  ></TextField>
                </Grid>
              </div>
            </div>

            <div className="row data-row">
              <div className="col-md-2 label-class">
                <span className="label-text">Reason</span>
              </div>
              <div className="col-md-10 select-bordered-div">
                <Grid item md={12} xs={12}>
                  <TextField
                    fullWidth
                    // label="Select State"
                    name="state"
                    label="Reason For Blocking/Unblocking"
                    onChange={e => {
                      this.setState({ blockOrUnBlockReason: e.target.value });
                    }}
                    // select
                    // eslint-disable-next-line react/jsx-sort-props
                    // SelectProps={{ native: true }}
                    value={this.state.blockOrUnBlockReason}
                    variant="outlined"
                  ></TextField>
                </Grid>
              </div>
            </div>

            <br />
            <div className="row">
              <div className="col-md-8"></div>
              <div className="col-md-4">
                <Button
                  variant="contained"
                  color="primary"
                  component="span"
                  name="unblock"
                  style={{ margin: "5px" }}
                  onClick={this.unBlockAgent.bind(this)}
                  disabled={this.state.loadUnBlock}
                >
                  {this.state.loadUnBlock ? "LOADING..." : "UN-BLOCK"}
                </Button>
                {/* </div>
                            <div className='col-md-2'> */}
                <Button
                  variant="contained"
                  color="primary"
                  name="block"
                  onClick={this.blockAgent.bind(this)}
                  component="span"
                  disabled={this.state.loadBlock}
                >
                  {this.state.loadBlock ? "LOADING..." : "BLOCK"}
                </Button>
              </div>
            </div>
          </form>
        </div>

        <br />
        <br />
        <br />

        <div className="container hole-container" style={{ width: "60em" }}>
          <h6 className="page-header">Logout Client</h6>
          <form className="form-style" id="logoutForm">
            <div className="row data-row">
              <div className="col-md-2 label-class">
                <span className="label-text">Email</span>
              </div>
              <div className="col-md-10 select-bordered-div">
                <Grid item md={12} xs={12}>
                  <TextField
                    fullWidth
                    // label="Select State"
                    name="state"
                    label="Client Email"
                    onChange={e => {
                      this.setState({ logoutMobile: e.target.value });
                    }}
                    // select
                    // eslint-disable-next-line react/jsx-sort-props
                    // SelectProps={{ native: true }}
                    // value={values.state}
                    variant="outlined"
                  ></TextField>
                </Grid>
              </div>
            </div>

            <br />
            <div className="row">
              <div className="col-md-10"></div>
              <div className="col-md-2">
                <Button
                  variant="contained"
                  onClick={this.logoutAgent.bind(this)}
                  color="primary"
                  component="span"
                  disabled={this.state.loadLogoutAgent}
                >
                  {this.state.loadLogoutAgent ? "LOADING..." : "LOGOUT"}
                </Button>
              </div>
            </div>
          </form>
        </div>
      </>
    );
  }
}

export default DeleteClient;
